import { useCallback, useState } from 'react';

export type EssayModal =
  | 'cancel'
  | 'change'
  | 'send'
  | 'unload'
  | 'error'
  | 'confirmation';

const initialState: Record<EssayModal, boolean> = {
  cancel: false,
  change: false,
  send: false,
  unload: false,
  error: false,
  confirmation: false,
};

export function useModal() {
  const [opened, setOpened] = useState(initialState);

  // modal('cancel') opens, modal('cancel', false) closes
  const modal = useCallback((name: EssayModal, isOpen = true) => {
    setOpened((prev) => (prev[name] === isOpen ? prev : { ...prev, [name]: isOpen }));
  }, []);

  return { modal, opened };
}
